/**
 * Curated outbound resource hub — the E-E-A-T anchor.
 *
 * Two jobs:
 *  1. SEO E-E-A-T: linking out to recognized authorities is a trust signal and
 *     gives the page editorial context.
 *  2. YMYL safe-zone: by explicitly pointing parents to the real authorities on
 *     child development and health, we make our own non-diagnostic role clear.
 *     Stratos recognizes and records achievements; we do not screen, diagnose,
 *     or advise on development. These links are where that work belongs.
 *
 * Keep every link to a genuinely authoritative, stable source (.gov / .org /
 * recognized nonprofit). Never link out to a competing commercial service.
 */

export const RESOURCE_GROUPS = [
  {
    id: 'development',
    label: 'Understanding Early Development',
    blurb:
      'Authoritative, parent-friendly guides to how children grow. These are the bodies we defer to on anything developmental.',
    links: [
      {
        title: 'CDC — Learn the Signs. Act Early.',
        href: 'https://www.cdc.gov/ncbddd/actearly/index.html',
        source: 'Centers for Disease Control and Prevention',
        desc: 'Free milestone checklists and guidance from the U.S. CDC.',
      },
      {
        title: 'HealthyChildren.org — Ages & Stages',
        href: 'https://www.healthychildren.org/English/ages-stages/Pages/default.aspx',
        source: 'American Academy of Pediatrics',
        desc: 'Pediatrician-reviewed guidance for every age and stage.',
      },
      {
        title: 'ZERO TO THREE — Early Development',
        href: 'https://www.zerotothree.org/early-learning/',
        source: 'ZERO TO THREE',
        desc: 'Research-based resources for the first three years.',
      },
    ],
  },
  {
    id: 'learning',
    label: 'Play & Early Learning',
    blurb:
      'Evidence-based ideas for learning through play — the same warm, play-based spirit our verification sessions are built on.',
    links: [
      {
        title: 'NAEYC — For Families',
        href: 'https://www.naeyc.org/our-work/for-families',
        source: 'National Association for the Education of Young Children',
        desc: 'How young children learn best, from the leading early-ed body.',
      },
      {
        title: 'Vroom — Brain-Building Moments',
        href: 'https://www.vroom.org/',
        source: 'Vroom',
        desc: 'Free, science-backed activities that turn everyday moments into learning.',
      },
      {
        title: 'PBS KIDS for Parents',
        href: 'https://www.pbs.org/parents',
        source: 'PBS',
        desc: 'Trusted activities, milestones, and play ideas by age.',
      },
    ],
  },
  {
    id: 'support',
    label: 'When You Have Questions',
    blurb:
      'If you ever have a concern about your child’s development, start here — with a professional, not with us.',
    links: [
      {
        title: 'Find Your State’s Early Intervention Program',
        href: 'https://www.cdc.gov/ncbddd/actearly/parents/states.html',
        source: 'CDC',
        desc: 'Free developmental evaluation services in every U.S. state.',
      },
      {
        title: 'Find a Pediatrician',
        href: 'https://www.healthychildren.org/English/tips-tools/find-pediatrician/Pages/Pediatrician-Referral-Service.aspx',
        source: 'American Academy of Pediatrics',
        desc: 'Locate a board-certified pediatrician near you.',
      },
    ],
  },
];
